import axios from 'axios'
import { DATAMASTER_ENDPOINT } from '../../endpoints'

export async function deleteDatamaster(datamasterId) {
  try {
    const response = await axios.delete(`${DATAMASTER_ENDPOINT}/${datamasterId}`)
    return response.data
  } catch (error) {
    return error
  }
}
